import { ApplicationsBreadcrumb } from '@/pages/Applications/ApplicationsBreadcrumbs'
import { AppAttributesFormV2 } from '../Forms/AppAttributesFormV2'
import { useCurrentApplication } from '../useCurrentApplication'
import { MAIN_HEADER_HEIGHT, PADDING_GAP, PAGE_HEADER_HEIGHT } from '@/catalog-apps/components/config'
import { ScrollArea } from '@/components/shadcn/scroll-area'
import { useNavigate } from 'react-router'

export function AppEditAttributes() {
  const application = useCurrentApplication()
  const navigate = useNavigate()
  return (
    <>
      <ApplicationsBreadcrumb title="Edit attributes" breadcrumbLink={{ label: 'Marketing', page: 'marketing' }} />
      <div className="flex w-full justify-center bg-background py-5 pl-16">
        <div
          style={{
            height: `calc(100vh - ${MAIN_HEADER_HEIGHT * 2}px - ${PAGE_HEADER_HEIGHT}px - ${PADDING_GAP * 4}px)`,
          }}
          className="bg-offwhite w-full max-w-4xl -translate-x-[50px] rounded-2xl py-5 pl-5 shadow"
        >
          <ScrollArea className="h-full pr-5">
            <AppAttributesFormV2
              selectedApp={application}
              // sheetTitle="Edit application attributes"
              // sheetDescription="Edit the attributes of the application."
              onSubmit={() => {
                navigate(`/applications/${application.appKey}/marketing`)
              }}
            />
          </ScrollArea>
        </div>
      </div>
    </>
  )
}
